import { useState, useEffect, useRef } from "react";
import { authFetch } from "../../App";
import { Trash2 } from "lucide-react";
import { API, fmtDateShort } from "./helpers";

export function InlineNote({ note, contactId, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(note.text);
  const textareaRef = useRef(null);

  useEffect(() => { if (editing && textareaRef.current) { textareaRef.current.focus(); textareaRef.current.select(); } }, [editing]);

  const save = async () => {
    const trimmed = val.trim();
    if (!trimmed || trimmed === note.text) { setEditing(false); setVal(note.text); return; }
    await authFetch(`${API}/crm/contacts/${contactId}/notes/${note.id}`, {
      method: "PUT", body: JSON.stringify({ text: trimmed }),
    });
    setEditing(false);
    onChanged();
  };

  const remove = async () => {
    await authFetch(`${API}/crm/contacts/${contactId}/notes/${note.id}`, { method: "DELETE" });
    onChanged();
  };

  return (
    <div className="pb-1 border-b border-gray-50 group relative" data-testid={`note-${note.id}`}>
      <div className="flex items-center justify-between">
        <p className="text-[10px] text-gray-400 whitespace-nowrap overflow-hidden text-ellipsis">
          {note.aktivitaetstyp && note.aktivitaetstyp !== "Notiz" && <span className="text-blue-500 font-medium">{note.aktivitaetstyp} · </span>}
          {fmtDateShort(note.created_at)} · {note.created_by}
        </p>
        <button onClick={remove} className="text-gray-200 hover:text-red-500 opacity-0 group-hover:opacity-100 flex-shrink-0" data-testid={`delete-note-${note.id}`}>
          <Trash2 className="w-2.5 h-2.5" />
        </button>
      </div>
      {editing ? (
        <textarea
          ref={textareaRef}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onBlur={save}
          onKeyDown={(e) => { if (e.key === "Escape") { setVal(note.text); setEditing(false); } if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); save(); } }}
          className="text-[11px] text-gray-800 leading-tight w-full bg-blue-50 border border-blue-200 rounded px-1 py-0.5 outline-none resize-none"
          rows={2}
          data-testid={`inline-edit-note-${note.id}`}
        />
      ) : (
        <p
          className="text-[11px] text-gray-800 leading-tight cursor-text hover:bg-gray-50 rounded px-0.5 -mx-0.5 line-clamp-2"
          onDoubleClick={() => setEditing(true)}
          title={note.text}
          data-testid={`note-text-${note.id}`}
        >
          {note.text}
        </p>
      )}
    </div>
  );
}
